export class Action {
  isSeparator?: boolean;
  isGroup?: boolean;
}
